import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiSkeleton(theme: Theme): MuiThemeComponentOverride<"MuiSkeleton"> {
  return {
    MuiSkeleton: {
      defaultProps: { animation: "wave", width: "100%" },
      styleOverrides: {
        root: {
          backgroundColor: theme.palette.brand.orange[100].lighter,
          border: `1px solid ${theme.palette.brand.orange[100].light}`,
          borderRadius: "4px",
          transform: "unset",
        },
        wave: {
          "::after": {
            // rgb value is ORANGE['100'].light
            background: `linear-gradient(90deg, transparent, rgba(255,235,214,0.4), transparent)`,
          },
        },
      },
    },
  };
}
